import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Form, Input, Space } from "antd";
import { getManagerDependingVariables } from "@devowl-wp/cookie-consent-web-client";
import { useFormService } from "../../../../../contexts/formService.js";
import { useI18n } from "../../../../../contexts/i18n.js";
import { LearnMoreTag } from "../../../../common/learnMoreTag.js";
import { Notices } from "../../../../common/notices.js";
const FormServiceFieldHandlingTagManagerEventName = ()=>{
    const { __ } = useI18n();
    const { setCookiesViaManager, createdTagManagers, isGcm, template } = useFormService();
    const { managerLabel, features, expectedManagerPresetId } = getManagerDependingVariables(setCookiesViaManager, {
        isGcm,
        presetId: template?.identifier
    });
    return features.events && /*#__PURE__*/ _jsxs(Form.Item, {
        label: __("Event names for %s", managerLabel),
        required: true,
        children: [
            /*#__PURE__*/ _jsxs(Space.Compact, {
                block: true,
                style: {
                    maxWidth: 400,
                    width: "100%",
                    marginRight: 10,
                    marginBottom: 5
                },
                children: [
                    /*#__PURE__*/ _jsx(Input, {
                        value: __("Opt-in"),
                        readOnly: true,
                        tabIndex: -1,
                        className: "rcb-antd-input-compact-label"
                    }),
                    /*#__PURE__*/ _jsx(Form.Item, {
                        name: "tagManagerOptInEventName",
                        noStyle: true,
                        style: {
                            flex: 1,
                            minWidth: 0
                        },
                        children: /*#__PURE__*/ _jsx(Input, {})
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Space.Compact, {
                block: true,
                style: {
                    maxWidth: 400,
                    width: "100%",
                    marginRight: 10,
                    marginBottom: 5
                },
                children: [
                    /*#__PURE__*/ _jsx(Input, {
                        value: __("Opt-out"),
                        readOnly: true,
                        tabIndex: -1,
                        className: "rcb-antd-input-compact-label"
                    }),
                    /*#__PURE__*/ _jsx(Form.Item, {
                        name: "tagManagerOptOutEventName",
                        noStyle: true,
                        style: {
                            flex: 1,
                            minWidth: 0
                        },
                        children: /*#__PURE__*/ _jsx(Input, {})
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "description",
                children: /*#__PURE__*/ _jsx(LearnMoreTag, {
                    url: __("https://devowl.io/knowledge-base/real-cookie-banner-with-google-tag-manager-or-matomo-tag-manager/")
                })
            }),
            /*#__PURE__*/ _jsx(Form.Item, {
                noStyle: true,
                shouldUpdate: (prevValues, curValues)=>prevValues.tagManagerOptInEventName !== curValues.tagManagerOptInEventName || prevValues.tagManagerOptOutEventName !== curValues.tagManagerOptOutEventName,
                children: ({ getFieldValue })=>{
                    const inEventName = getFieldValue("tagManagerOptInEventName");
                    const outEventName = getFieldValue("tagManagerOptOutEventName");
                    return (inEventName.length > 0 || outEventName.length > 0) && !!managerLabel && !createdTagManagers[expectedManagerPresetId].length && /*#__PURE__*/ _jsx(Notices, {
                        notices: [
                            {
                                message: __("You have not yet defined a %s service. To use event names, you must create a %s service.", managerLabel, managerLabel),
                                severity: "warning"
                            }
                        ]
                    });
                }
            })
        ]
    });
};
export { FormServiceFieldHandlingTagManagerEventName };
